import { lazy } from "react";
import Loadable from "app/components/Loadable";

const HomePage = Loadable(lazy(() => import("./HomePage")));

// const Auth0Login = Loadable(lazy(() => import("./login/Auth0Login")));

const homeRoutes = [
  {
    path: "/home",
    element: (
      <HomePage />
    ),
  },
];

export default homeRoutes;
